// extracted by mini-css-extract-plugin
export default {"orderValue":"eD1r1","orderValue__labelText":"bKseX"};